import { render } from "./UpdateAccessProvider.vue?vue&type=template&id=41a5279c&scoped=true"
import script from "./UpdateAccessProvider.vue?vue&type=script&lang=js"
export * from "./UpdateAccessProvider.vue?vue&type=script&lang=js"

import "./UpdateAccessProvider.vue?vue&type=style&index=0&id=41a5279c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a5279c"]])

export default __exports__